export default __webpack_public_path__ + "static/media/Home-foto-header-sports-Tower-viajes-mobile.87c214f1.jpg";